<template>
    <button class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-bg-[#33b35a] tw-text-white tw-font-semibold tw-rounded-xl tw-shadow-lg tw-cursor-not-allowed" type="button" disabled>
        <i class="fa-solid fa-circle-notch tw-animate-spin" aria-hidden="true"></i>
        Carregando...
    </button>
</template>
<style>
</style>